import Vue from 'vue'
import App from './App.vue'
import store from './store/store'
import router from './router/router'

function readTextFile(file, callback) {
  var rawFile = new XMLHttpRequest();
  rawFile.overrideMimeType("application/json");
  rawFile.open("GET", file, true);
  rawFile.onreadystatechange = function() {
      if (rawFile.readyState === 4 && rawFile.status == "200") {
          callback(rawFile.responseText);
      }
  }
  rawFile.send(null);
}

Vue.config.productionTip = false

let dataset = [], ecpmProjects = [];

let statusPlaces = {
  Retentionist:             {states: [], countries: []},
  Moratorium:               {states: [], countries: []},
  CommonRightAbolitionist : {states: [], countries: []},
  Abolitionist:             {states: [], countries: []}
};

let moratoriumPlaces = {
  InFavour:   {states: [], countries: []},
  Against:    {states: [], countries: []},
  Abstention: {states: [], countries: []},
  Absence:    {states: [], countries: []}
};

let op2Places = {
  Ratified:     {states: [], countries: []},
  NotRatified:  {states: [], countries: []},
};

let igoPlaces = {};

let peopleInDeathRowDataYear = null;
let executionsNumberDataYear = null;
let condemnationsDataYear = null;
let moratoriumDataYear = null;

const MORATORIUM = 'moratorium';

readTextFile("./data/igo.json", function(text){
  var igoJson = JSON.parse(text);

  igoJson.forEach(element => {
    let igoId = element['igoshortnameen'];
    igoPlaces[igoId] = element;
  });
});

readTextFile("./data/data.json", function(text){
  var data = JSON.parse(text);

  data.forEach(element => {
    let iso = element['iso'];
    dataset[iso] = element;

    // Get year of datas
    if (peopleInDeathRowDataYear == null || executionsNumberDataYear == null) {
      for (const [key] of Object.entries(element)) {
        if (key.includes('peopleindeathrow')) peopleInDeathRowDataYear = key.substr(-4)
        if (key.includes('executionsnumber')) executionsNumberDataYear = key.substr(-4)
        if (key.includes('condemnations')) condemnationsDataYear = key.substr(-4)
        if (key.includes(MORATORIUM)) moratoriumDataYear = key.substr(-4)
      }
    }

    // Name correction for Georgia, to prevent errors between the US states and the country
    if (element['placenameen'] === "Georgia (US)") element['placenameen'] = "Georgia";

    // Populate the ECPM project array
    if (element['ecpmproject'] === "x") ecpmProjects.push(iso)

    // Populate the moratorium 2018 ratification array
    switch (element[MORATORIUM + moratoriumDataYear]) {
      case "Oui":
        iso.includes("-") ? moratoriumPlaces.InFavour.states.push(element['placenameen']) : moratoriumPlaces.InFavour.countries.push(iso); break;
      case "Non":
        iso.includes("-") ? moratoriumPlaces.Against.states.push(element['placenameen']) : moratoriumPlaces.Against.countries.push(iso); break;
      case "Abstention":
        iso.includes("-") ? moratoriumPlaces.Abstention.states.push(element['placenameen']) : moratoriumPlaces.Abstention.countries.push(iso); break;
      case "Absent":
        iso.includes("-") ? moratoriumPlaces.Absence.states.push(element['placenameen']) : moratoriumPlaces.Absence.countries.push(iso); break;
      default:
        break;
    }

    // Populate the op2 ratification array
    switch (element['op2']) {
      case "x":
        iso.includes("-") ? op2Places.Ratified.states.push(element['placenameen']) : op2Places.Ratified.countries.push(iso); break;
      case undefined:
        iso.includes("-") ? op2Places.NotRatified.states.push(element['placenameen']) : op2Places.NotRatified.countries.push(iso); break;
      default:
        break;
    }

    // Populate the death penalty status array
    switch (element['status']) {
      case 1:
        iso.includes("-") ? statusPlaces.Retentionist.states.push(element['placenameen']) : statusPlaces.Retentionist.countries.push(iso); break;
      case 2:
        iso.includes("-") ? statusPlaces.Moratorium.states.push(element['placenameen']) : statusPlaces.Moratorium.countries.push(iso); break;
      case 3:
        iso.includes("-") ? statusPlaces.CommonRightAbolitionist.states.push(element['placenameen']) : statusPlaces.CommonRightAbolitionist.countries.push(iso); break;
      case 4:
        iso.includes("-") ? statusPlaces.Abolitionist.states.push(element['placenameen']) : statusPlaces.Abolitionist.countries.push(iso); break;
      default:
        break;
    }

    // Populate the igo array
    if (element['igo'] !== undefined && element['igo'] !== "") {
      let igos = element['igo'].split(",").map(function(item) {
        return item.trim();
      });
      igos.forEach(igo => {
        if (igoPlaces[igo] !== undefined) {
          if (igoPlaces[igo]['places'] === undefined) igoPlaces[igo]['places'] = []
          igoPlaces[igo]['places'].push(iso)
        } else {
          console.log("Cet IGO n'existe pas dans le fichier igo.json : " + igo)
        }
      })
    }
  });
  Vue.prototype.$dataset = dataset
  Vue.prototype.$igoPlaces = igoPlaces
  Vue.prototype.$ecpmProjects = ecpmProjects
  Vue.prototype.$statusPlaces = statusPlaces
  Vue.prototype.$moratoriumPlaces = moratoriumPlaces
  Vue.prototype.$op2Places = op2Places
  Vue.prototype.$peopleInDeathRowDataYear = peopleInDeathRowDataYear,
  Vue.prototype.$executionsNumberDataYear = executionsNumberDataYear;
  Vue.prototype.$condemnationsDataYear = condemnationsDataYear;
  Vue.prototype.$moratoriumDataYear = moratoriumDataYear;
  Vue.prototype.$ECPM_HOST = "https://ecpm.org";
  Vue.prototype.$COLORS = {
    // 1: '#B84422', // Retentionnist
    // 2: '#D4771B', // Moratorium
    // 3: '#D4CC18', // Common rights Abolitionist
    // 4: '#76B7AA',  // Abolitionist
    1: '#d84e28', // Retentionnist
    2: '#f57f22', // Moratorium
    3: '#d0ce28', // Common rights Abolitionist
    4: '#38beac',  // Abolitionist
    "": '#EB9A13',
    "x": '#74C487',
    "Oui": '#74C487',
    "Non": '#EB9A13',
    "Abstention": '#60968C',
    "Absent": '#74A9C4',
    "nonIgo": '#ededed'
  }

  router.afterEach(() => {
    store.commit('updateFullPath', window.location.href)
  })

  new Vue({
    router,
    render: h => h(App),
    created() {
      let uri = window.location.search.substring(1);
      let params = new URLSearchParams(uri);
      if (params.get("map") != null) store.commit('updateActiveNavbarItem', params.get("map"));
      if (params.get("treaty") != null) store.commit('updateTreaty', params.get("treaty"));
      if (params.get("igo") != null) store.commit('updateActiveIGO', params.get("igo"));
      if (params.get("place") != null) {
        store.commit('toggleInfoPanel', true);
        store.commit('updateActiveCountry', params.get("place"));
      }
      let lang = params.get("lang");
      if (lang != null) store.commit('updateLang', (lang === "en" ? { lang: 'en', name: "English" } : { lang: 'fr', name: "Français" }));
    },
    store
  }).$mount('#app')

  document.documentElement.lang = store.state.language.lang;

  // First we get the viewport height and we multiple it by 1% to get a value for a vh unit
  let vh = window.innerHeight * 0.01;
  // Then we set the value in the --vh custom property to the root of the document
  document.documentElement.style.setProperty('--vh', `${vh}px`);

  // We listen to the resize event
  window.addEventListener('resize', () => {
    // We execute the same script as before
    let vh = window.innerHeight * 0.01;
    document.documentElement.style.setProperty('--vh', `${vh}px`);
  });
});